export enum PaymentMethodType {
  Giropay = "giropay",
  Alipay = "alipay",
  Ideal = "ideal",
  SepaInstantTransfer = "sepa_instant_transfer",
  GooglePay = "google_pay",
  NetbankingEmandates = "netbanking_emandates",
  KlarnaPayNow = "klarna_pay_now",
  Dotpay = "dotpay",
  Unionpay = "unionpay",
  DirectDebit = "direct_debit",
  FasterPayments = "faster_payments",
  Generic = "generic",
  Sofort = "sofort",
  AmazonPayments = "amazon_payments",
  Upi = "upi",
  Venmo = "venmo",
  ApplePay = "apple_pay",
  Bancontact = "bancontact",
  AutomatedBankTransfer = "automated_bank_transfer",
  PaypalExpressCheckout = "paypal_express_checkout",
  WechatPay = "wechat_pay",
  PayTo = "pay_to",
  Card = "card",
}

export interface PaymentMethod {
  id: string;
  customer_id: string;
  type: PaymentMethodType;
  card?: {
    masked_number: string;
    brand: string;
    last4: string;
    expiry_year: number;
    expiry_month: number;
    funding_type: string;
  };
  status: string;
  gateway?: string;
  issuing_country: string;
  primary: boolean;
}
